var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2v16h8.482l4.851-4.88V2H3Zm11.852 10.51-3.99 4.008h-6.38V3.481h10.37v9.028Zm-5.63 2.823h1.482V12.37h2.963V10.89H9.222v4.444ZM12.778 5.26H6.556v1.482h6.222V5.259Zm0 2.667H6.556v1.481h6.222V7.926Z",
    fill: "#105880"
  })));
};
export default SvgFile;